module.exports = __webpack_public_path__ + "static/media/main idea.eb8ba709.mp3";